import { ButtonRules, StyledButton } from '@canopysecurity/component-library';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  CardContainer,
  CardTitle,
  CardValue,
} from '../../StyledComponents/Card';
import { StyledInput } from '../../StyledComponents/Input';
import SideBar from '../home/SideBar';

interface DeviceSearchProps {
  serialNumber: string;
  setSerialNumber: (value: string) => void;
  loading: boolean;
  setSkipQuery: (skip: boolean) => void;
}

export const DeviceSearch = (props: DeviceSearchProps) => {
  const { serialNumber, setSerialNumber, loading, setSkipQuery } = props;
  const [localSerialNumber, setLocalSerialNumber] = useState(serialNumber);

  const [searchParams, setSearchParams] = useSearchParams();

  console.log(
    'DeviceSearch render with serialNumber:',
    searchParams,
    'localSerialNumber:',
    localSerialNumber,
  );

  const handleSubmit = () => {
    setSerialNumber(localSerialNumber);
    setSkipQuery(false);
    setSearchParams({ serialNumber: localSerialNumber });
  };
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flexBasis: '20%' }}>
        <SideBar />
      </div>
      <div style={{ flexBasis: '60%' }}>
        <CardContainer>
          <CardTitle>Device Details</CardTitle>
          <div style={{ display: 'flex' }}>
            <div style={{ flexBasis: '40%' }}>
              <CardValue>Search For Device (serial number)</CardValue>
            </div>
            <div style={{ flexBasis: '60%' }}>
              <form
                style={{ display: 'flex', flexDirection: 'row' }}
                onChange={() => setSkipQuery(true)}
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
              >
                <div style={{ flexBasis: '50%', paddingRight: '20px' }}>
                  <StyledInput
                    type="text"
                    value={localSerialNumber}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setLocalSerialNumber(e.target.value)
                    }
                    aria-label="Serial number input"
                  />
                </div>
                <div style={{ flexBasis: '50%', paddingLeft: '20px' }}>
                  <StyledButton
                    disabled={loading || !localSerialNumber}
                    onPress={() => {
                      handleSubmit();
                    }}
                    buttonRules={ButtonRules.primaryA}
                    aria-label="Search for device"
                  >
                    Search
                  </StyledButton>
                </div>
              </form>
            </div>
          </div>
        </CardContainer>
      </div>
    </div>
  );
};
